<cm-infinite-list [count]="$totalCount()" [intersectionStatusChange]="$pageFilledStatusChange()" class="cm-items-list">
    <cm-list-info
        cm-list-header
        [parentList]="this"
        [allowStandardUpdates]="$can().update.picture(null, 'batch')"
        [stateLabels]="$stateLabels()"
        [count]="$totalCount()"
        [batchDownloadData]="$batchDownloadData()"
    ></cm-list-info>
    @for (picture of $items(); track picture.trackId) {
        @if (picture.placeholder) {
            <cm-card-placeholder @fadeInPlaceholder></cm-card-placeholder>
        } @else if (picture.error) {
            <cm-card-error @fadeInPlaceholder></cm-card-error>
        } @else {
            <cm-entity-card
                @fadeInCard
                [entity]="picture.data"
                [defaultTitle]="false"
                [defaultSubtitle]="$can().read.picture(picture.data, 'subtitle')"
                [entityLink]="cardLink(picture.data)"
                [entityQueryParamsHandling]="'preserve'"
                [enableDropZone]="$can().update.picture({organization: $organization()})"
                (dropZoneUpload)="dropZoneUploadSave(picture.data, $event)"
                (dragstart)="dragStart($event, picture.data)"
                (dragenter)="dragEnter($event, picture.data)"
                (dragend)="dragEnd()"
                (drop)="drop($event, picture.data)"
                ondragover="return false"
                ondrop="return false"
                [draggable]="$selectedTab() !== 'projects'"
                [ngClass]="{'cm-drag-over': $isSorting() && $dragTarget() != undefined && picture.data.id === $dragTarget()?.id}"
                class="cm-picture"
                [multiThumbnailIds]="thumbnailIds(picture.data)"
            >
                <ng-container cm-background>
                    @if (showInProgressOverlay(picture.data)) {
                        <div class="cm-picture-overlay">In Progress</div>
                    }
                </ng-container>
                <ng-container cm-top-left>
                    @if ($can().read.picture(picture.data, "pictureAnnotationTags")) {
                        <div class="cm-tag-labels-container">
                            <cm-tag-labels [tags]="getTags(picture.data, Enums.TagType.PictureAnnotation)"></cm-tag-labels>
                        </div>
                    }
                    <div class="cm-action-container" (click)="$event.stopPropagation()">
                        @if ($can().read.picture(picture.data, "editor") && !(organizations.$current()?.type === OrganizationType.EnterpriseCloud)) {
                            <a [routerLink]="createLinkToEditor(picture.data)" queryParamsHandling="preserve" class="cm-action-icon-container">
                                <i class="far fa-pen-to-square cm-action-icon" matTooltip="Open editor"></i>
                            </a>
                        } @else {
                            <a
                                [routerLink]="[picture.data.id, 'revisions', picture.data.latestRevision?.number ?? 'new']"
                                queryParamsHandling="preserve"
                                class="cm-action-icon-container"
                            >
                                <i class="far fa-circle-info cm-action-icon" matTooltip="Open picture dialog"></i>
                            </a>
                        }
                        @if (picture.data.downloadUrl) {
                            <a href="{{ picture.data.downloadUrl }}" download="filename" class="cm-action-icon-container">
                                @if (picture.data.state == Enums.PictureState.Completed) {
                                    <i class="far fa-arrow-to-bottom cm-action-icon cm-download-high-res" matTooltip="Download high-res picture"></i>
                                } @else {
                                    <i class="far fa-arrow-to-bottom cm-action-icon" matTooltip="Download"></i>
                                }
                            </a>
                        }
                        @if ($can().update.picture(null, "priority")) {
                            <a (click)="setHighestPriority(picture.data)" class="cm-action-icon-container">
                                <i class="far fa-arrow-to-top cm-action-icon" matTooltip="Highest priority"></i>
                            </a>
                        }
                        @if (picture.data.template != null && $can().copy.picture(picture.data)) {
                            <a (click)="copyTemplate(picture.data, picture.data.set.id)" class="cm-action-icon-container">
                                <i class="far fa-copy cm-action-icon" matTooltip="Make a copy"></i>
                            </a>
                        }
                    </div>
                </ng-container>
                <ng-container cm-bottom-left>
                    @if ($can().update.picture(picture.data, "paymentState")) {
                        <cm-payment-state-label [item]="picture.data" [editable]="true" (stateChange)="updateItem({id: picture.data.id, paymentState: $event})">
                        </cm-payment-state-label>
                    }
                    @if ($can().read.picture(picture.data, "state")) {
                        <cm-state-label
                            [stateLabels]="Labels.PictureState"
                            [state]="picture.data.state"
                            [disableCompleted]="!$can().update.picture(picture.data, 'completion')"
                            [backgroundColor]="auth.$actingAsCustomer() && picture.data.nextActor === Enums.NextActor.Customer ? '#f13536' : undefined"
                            [editable]="$can().update.picture(picture.data, 'state')"
                            (stateChange)="updateItem({id: picture.data.id, state: $event})"
                        >
                        </cm-state-label>
                    }
                </ng-container>
                <ng-container cm-bottom-right>
                    @if ($can().create.userAssignment()) {
                        <cm-assign-user
                            [matMenuTriggerFor]="userMenu"
                            [matMenuTriggerData]="{entity: picture.data}"
                            [user]="picture.data.currentUserAssignment"
                            [nextActor]="picture.data.nextActor"
                        >
                        </cm-assign-user>
                    }
                </ng-container>
                <ng-container cm-title>
                    @if ($can().read.picture(picture.data, "shortLocation")) {
                        (P{{ picture.data.set.project.number }}, S{{ picture.data.set.number }})
                    }
                    <span [matTooltip]="picture.data.name"> Picture {{ picture.data.number }}{{ picture.data.name ? ":" : "" }} {{ picture.data.name }} </span>
                </ng-container>
                <ng-container cm-subtitle>
                    @if ($can().read.picture(picture.data, "assetInfos")) {
                        @if (
                            picture.data.assetInfos &&
                            (picture.data.assetInfos.new > 0 ||
                                picture.data.assetInfos.readyForShading > 0 ||
                                picture.data.assetInfos.shading > 0 ||
                                picture.data.assetInfos.review > 0 ||
                                picture.data.assetInfos.completed > 0)
                        ) {
                            <div class="cm-shaded-model-boxes">
                                <i class="far fa-loveseat"></i>
                                @if (picture.data.assetInfos.new != 0) {
                                    <div matTooltip="Info review" class="cm-shaded-model-info-box cm-dashed-border">
                                        {{ picture.data.assetInfos.new }}
                                    </div>
                                }
                                @if (picture.data.assetInfos.readyForShading != 0) {
                                    <div class="cm-shaded-model-info-box cm-grey-background">
                                        {{ picture.data.assetInfos.readyForShading }}
                                    </div>
                                }
                                @if (picture.data.assetInfos.shading != 0 || picture.data.assetInfos.review != 0) {
                                    <div matTooltip="In progress" class="cm-shaded-model-info-box cm-yellow-background">
                                        {{ picture.data.assetInfos.shading + picture.data.assetInfos.review }}
                                    </div>
                                }
                                @if (picture.data.assetInfos.completed != 0) {
                                    <div matTooltip="Completed" class="cm-shaded-model-info-box cm-green-background">
                                        {{ picture.data.assetInfos.completed }}
                                    </div>
                                }
                            </div>
                        }
                        <cm-comment-boxes [entity]="picture.data"></cm-comment-boxes>
                    } @else {
                        <div class="cm-project-set" [matTooltip]="picture.data.set.project.name + ' - ' + picture.data.set.name">
                            Project: {{ picture.data.set.project.number }}, Set: {{ picture.data.set.number }}
                        </div>
                    }
                </ng-container>
                <ng-container cm-details-bottom-right>
                    @if ($can().update.picture({organization: picture.data.organization, state: picture.data.state})) {
                        <i [matMenuTriggerFor]="pictureMenu" [matMenuTriggerData]="{picture: picture.data}" class="far fa-ellipsis-v cm-menu-dots"></i>
                    }
                </ng-container>
            </cm-entity-card>
        }
    }
</cm-infinite-list>
<mat-menu #userMenu [overlapTrigger]="false" [hasBackdrop]="true">
    <ng-template matMenuContent let-entity="entity">
        <cm-assign-user-dialog
            [user]="entity.currentUserAssignment"
            [nextActor]="entity.nextActor"
            (userChange)="updateAssignedUser(Enums.ContentTypeModel.Picture, entity, $event)"
            (nextActorChange)="updateItem({id: entity.id, nextActor: $event})"
        ></cm-assign-user-dialog>
    </ng-template>
</mat-menu>
<mat-menu #pictureMenu="matMenu" [overlapTrigger]="false" [hasBackdrop]="true">
    <ng-template matMenuContent let-picture="picture">
        <button mat-menu-item (click)="renamePicture(picture)">
            <span>Rename</span>
        </button>
        @if ($can().read.menu("renamePictureFile")) {
            <button mat-menu-item (click)="renameDataObject(picture)">
                <span>Rename file (last revision)</span>
            </button>
        }
        @if ($can().move.picture(picture)) {
            <button mat-menu-item (click)="movePicture(picture)">
                <span>Move</span>
            </button>
        }
        @if (picture.template && $can().copy.picture(picture)) {
            <button mat-menu-item (click)="copyTemplate(picture)">
                <span>Copy scene</span>
            </button>
            @if ($can().read.menu("goToTemplate")) {
                <button mat-menu-item>
                    <a [routerLink]="['../', 'templates', picture.template.id]" queryParamsHandling="">
                        <span>Go to template</span>
                    </a>
                </button>
            }
        }
        @if ($can().delete.picture(picture)) {
            <button mat-menu-item (click)="deletePicture(picture)">
                <span>Delete</span>
            </button>
        }
    </ng-template>
</mat-menu>
